export const nameShape = (...args: string[]): string =>
  // a shape's id is a function of the ids of its points
  args.sort().join(`/`)
